import { RouteRecordRaw } from "vue-router";
import { Role } from "@/store/auth/enum/AuthEnums";

const role = Role.admin;

export const adminRouter: RouteRecordRaw = {
  path: `/${role}`,
  redirect: "dashboard",
  component: () => import("@/layout/Layout.vue"),
  children: [
    {
      path: "dashboard",
      name: `${role}-dashboard`,
      component: () => import("@/views/dashboard/Dashboard.vue"),
    },
    {
      path: "settings",
      redirect: "division",
      component: () => import("@/layout/EmptyLayout.vue"),
      children: [
        {
          path: "project",
          redirect: "list",
          component: () => import("@/layout/EmptyLayout.vue"),
          children: [
            {
              path: "list",
              name: `${role}-settings-project-list`,
              component: () =>
                import("@/views/settings/project/ProjectList.vue"),
            },
            {
              path: "add",
              name: `${role}-settings-project-add`,
              component: () =>
                import("@/views/settings/project/ProjectEdit.vue"),
            },
            {
              path: "edit/:id",
              name: `${role}-settings-project-edit`,
              component: () =>
                import("@/views/settings/project/ProjectEdit.vue"),
            },
          ],
        },
        {
          path: "prefix",
          redirect: "list",
          component: () => import("@/layout/EmptyLayout.vue"),
          children: [
            {
              path: "list",
              name: `${role}-settings-prefix-list`,
              component: () => import("@/views/settings/prefix/PrefixList.vue"),
            },
            {
              path: "add",
              name: `${role}-settings-prefix-add`,
              component: () => import("@/views/settings/prefix/PrefixEdit.vue"),
            },
            {
              path: "edit/:id",
              name: `${role}-settings-prefix-edit`,
              component: () => import("@/views/settings/prefix/PrefixEdit.vue"),
            },
          ],
        },
        {
          path: "division",
          redirect: "list",
          component: () => import("@/layout/EmptyLayout.vue"),
          children: [
            {
              path: "list",
              name: `${role}-settings-division-list`,
              component: () =>
                import("@/views/settings/division/DivisionList.vue"),
            },
            {
              path: "add",
              name: `${role}-settings-division-add`,
              component: () =>
                import("@/views/settings/division/DivisionEdit.vue"),
            },
            {
              path: "edit/:id",
              name: `${role}-settings-division-edit`,
              component: () =>
                import("@/views/settings/division/DivisionEdit.vue"),
            },
          ],
        },
        {
          path: "teacher-apply",
          redirect: "list",
          component: () => import("@/layout/EmptyLayout.vue"),
          children: [
            {
              path: "list",
              name: `${role}-settings-teacher-apply-list`,
              component: () =>
                import("@/views/settings/teacherApply/TeacherApplyList.vue"),
            },
            {
              path: "add",
              name: `${role}-settings-teacher-apply-add`,
              component: () =>
                import("@/views/settings/teacherApply/TeacherApplyEdit.vue"),
            },
            {
              path: "edit/:id",
              name: `${role}-settings-teacher-apply-edit`,
              component: () =>
                import("@/views/settings/teacherApply/TeacherApplyEdit.vue"),
            },
          ],
        },
        {
          path: "system-config",
          redirect: "edit",
          component: () => import("@/layout/EmptyLayout.vue"),
          children: [
            {
              path: "edit",
              name: `${role}-settings-system-config-edit`,
              component: () =>
                import("@/views/settings/systemConfig/SystemConfigEdit.vue"),
            },
          ],
        },
      ],
    },
  ],
};
